import { render } from "./Empty.vue?vue&type=template&id=3b5d0f14&scoped=true"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=3b5d0f14&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5d0f14"]])

export default __exports__